

export const corseLink = "https://cors-anywhere.herokuapp.com/"

export const notionApiLink = (databaseId) => `https://api.notion.com/v1/databases/${databaseId}/query`;

export const notionApiHeaders = {
    "Authorization": "Bearer ntn_G48045609134oShCVqyLWXw5Sr0pFNOztepmJj24v42axL",
    "Content-Type": "application/json",
    "Notion-Version": "2022-06-28",
}
